// The cards. This file is the writing for every spell: the name, the blurb,
// the prompt, and the lines a spell says when it lands. It is Rob's file.
//
// A mechanic with no entry here runs on its spec and shows in the spec
// style. A blank field counts as not written. Fill in any field and the
// surface switches to the voice as soon as every shown field has one. HOMEWORK.md lists the mechanics and the hooks.
//
// A line is a template. {who} is the piece the spell hit, as "Gold's pawn on
// e4". Each mechanic's spec in src/spells/mechanics names the vars it fills.
//
// Shape of one entry:
//
//   'add-knight-moves': {
//     name: '',
//     blurb: '',
//     prompt: '',
//     lines: { cast: '', castCombo: '' },
//   },

import type { SpellCard, SpellId } from '../spells/types';

export const CARDS: Readonly<Partial<Record<SpellId, SpellCard>>> = {
  // Rob's name, 2026-10-14, when the spell became ally only: "i could see calling this like
  // Skunkworks and it's ally-only ... an unstable experimental process". It was Garrett's
  // Transmogrify. The blurb said "Any piece", so it went. The blurb, the prompt, and the lines are open.
  'change-kind': {
    name: 'Skunkworks',
  },
  // Garrett's name. The blurb, the prompt, and the lines are open.
  'push-pieces': {
    name: 'Knock Knock',
    blurb: 'Target now displaces pieces into adjacent squares instead of capturing',
  },
  // Garrett's name. The blurb and the lines are open.
  'clone-square': {
    name: 'Clone Hole',
    blurb: 'Target a 3x3 square. One empty space dupes any piece that lands there (next 2 turns)',
  },
  // Garrett's name. Rob's blurb was "Target ally advances until it can't anymore (avoids pits)".
  // It went on 2026-10-15, when the spell took a piece of either side. The blurb, the prompt,
  // and the lines are open.
  'run-forward': {
    name: 'Eager Beaver',
  },
  // Garrett's name. The blurb, the prompt, and the lines are open.
  'sacrifice-pawns': {
    name: 'Pawn Shop',
    blurb: 'Sacrifice 2-3 adjoining nonroyal pawns to gain a more powerful piece',
  },

  // No name yet. A blank field shows the spec.
  'add-knight-moves': { name: 'Enhorsen', blurb: 'Grant target ally knight moves' },
  'extra-life': {
    name: 'Creatine',
    blurb: 'Target ally gains another life (a would-be capture bounces)',
  },
  'copy-abilities': {
    name: 'Distillation',
    blurb: "Copy target ally's move set onto a random neighboring piece",
  },
  'make-royal': {
    name: 'Cinderella',
    blurb: 'Target nonroyal ally becomes royal (must be captured for a win)',
  },
  'kill-captor': {
    name: 'Grim Decoy',
    blurb: 'If captured, target nonroyal ally removes its capturer',
  },
  'move-to-own-half': {
    name: 'Homecoming',
    blurb: 'Move target ally to any open square on your side',
  },
  'defuse-bomb': { name: 'Wirecutters', blurb: 'Defuse an active explosion countdown' },
  'stop-piece': { name: 'Hold Up', blurb: "Target enemy can't move for two turns" },
  'explode-later': {
    name: 'Ominous Timer',
    blurb: 'Target nonroyal explodes in four turns, eliminating its neighbors',
  },
  'pawn-changes-side': {
    name: 'Benedict Pawnold',
    blurb: 'A random enemy nonroyal pawn now works for you',
  },
  'trade-squares': {
    name: 'Square Dance',
    blurb: 'Swap three random nonroyal pairs of both allies and enemies',
  },
  'deadly-square': {
    name: 'Trapdoor',
    blurb: 'Next 2 turns: Target square removes any piece that crosses or lands there',
  },
  'extra-rolls': { name: 'Roll Away', blurb: '' },
  'enemy-lines': {
    name: 'Enemy Lines',
    blurb: 'Transport any nonroyal to a random empty square on its enemy side; end your turn',
  },
  'clone-bud': { name: 'Mitosis', blurb: 'Clones this piece onto an adjacent square in 3 turns' },
  'suggest-best': { name: 'Good Idea', blurb: 'Get the best available next-move suggestion' },
  'roll-discount': { name: 'Divine Discount', blurb: 'Your next two rolls cost one less energy' },
  'checkers-energy': {
    name: 'Checkers Energy',
    blurb: 'Next time this piece captures, it moves again',
  },
  'piece-downgrade': { name: 'Deskilling', blurb: 'Downgrade an enemy piece by one move type' },
  'forced-peace': { name: 'Chill Pill', blurb: 'Nobody may capture any pieces for a turn' },
  'lost-energy': { name: 'Demotivation', blurb: "Next two turns: Enemy can't roll" },
  'new-scroll': { name: 'Frantic Scribbles', blurb: 'Add a random scroll into an open slot' },
  'row-scramble': { name: 'Rowndabout', blurb: 'Shuffle any row on the board' },
};
